import { compose } from 'recompose';
import { withFormUtilities } from 'components/common';
import withChartMetadataState from './withChartMetadata';
import withSaveAndDiscardHandlers from './withSaveAndDiscardHandlers';

const enhancers = [withFormUtilities, withChartMetadataState, withSaveAndDiscardHandlers];
export default compose(...enhancers);
